var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.tag,{ref:"root",tag:"component",staticClass:"mstIntersection"},[_vm._t("default",function(){return [_c('div',{staticClass:"mstIntersection__empty"})]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }